export const Private = () => {
  return (
    <div className="flex justify-center bg-gradient-to-br from-[#FFFFFF] via-[#B9C8FF] to-[#3BE1FE] ">
      <div className="pt-[180px] pb-[100px] px-[15rem] w-[1920px]">
        <div className="h-[460px]  flex justify-between items-center gap-[50px]">
          <div className="flex flex-col max-w-[779px] justify-between  h-full py-[47px]">
            <div className="max-w-[500px] bg-gradient-to-r from-[#619BFF] to-[rgba(198,225,255,0)] rounded-[10px] px-[10px] py-[4px] ">
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-bold text-[25px] text-[#FFFFFF]">
                光年自建K-WAN组网解决方案
              </div>
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-bold text-[50px] text-[#333333]">
              企业私有化组网
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-regular text-[24px] text-[#333333]">
              根据出海企业的业务需求，定制高性价比的专属全球网络连接方案，组建自己的全球专用内部互联网络，实现跨国分支机构异地数据互通互联，支持后期拓展定制
            </div>
            <div className="w-[170px] h-[60px] bg-gradient-to-br from-[#5F97FF] to-[#0182FF] rounded-[10px] flex items-center justify-center mt-[30px]">
              <a
                href="https://t22qshgkpd.jiandaoyun.com/f/68cb7a5580eabb69297c524b"
                target="_blank"
              >
                <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[25px] text-[#FFFFFF]">
                  立即咨询
                </div>
              </a>
            </div>
          </div>

          <div>
            <img
              className="w-[490px] min-w-[490px] h-[490px]"
              src={"/imgs/private/1.png"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
